// **Author:** Vijay 
import { Routes, Route, Link, BrowserRouter } from "react-router-dom";
import Login from "../pages/auth/Login";
import Register from "../pages/auth/Register";
import { AuthProvider } from "../context/AuthContext";
import Dashboard from "../pages/admin/dashboard/Index";
import PrivateRoute from "../components/PrivateRoute";
import AdminLayouts from "../layout/AdminLayout";
import Transfer from "../pages/transfer";
import Beneficiaries from "../pages/beneficiaries";
import Accountsummary from "../pages/AccountSummary/Accountsummary";
import AccountDetails from "../pages/Account/AccountDetails";
function Router() {
  return (
    <div>
      {/* Example navigation */}
      {/* <nav style={{ marginBottom: 20 }}>
        <Link to="/">Home</Link> |{' '}
      </nav> */}
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            {/* Example protected route: */}
            {/* <Route path='/admin/dashboard' element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } /> */}
            <Route element={<PrivateRoute Layout={AdminLayouts} />}>
              <Route path="/admin/dashboard" element={<Dashboard />} />
              <Route path="/admin/transfer" element={<Transfer />} />
              <Route path="/admin/beneficiaries" element={<Beneficiaries />} />
              <Route path="/admin/account-summary" element={<Accountsummary />} />
              <Route path="/admin/account-details" element={<AccountDetails />} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default Router;
